import { FC, lazy, Suspense, SyntheticEvent, useEffect } from 'react';
import { IconButton } from '@mui/material';
import { Notifications as NotificationsIcon, NotificationsNone as NotificationsNoneIcon } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';

import { snackbarStorage, snackbarStorageKey } from '/storage/sessionStorage/snackBarHistory';
import { notificationsToolkit } from '/store/toolkits';
import { useMultipleModals } from '/hooks';

import { NotificationChip } from './styles';

export const NotificationContent = lazy(() =>
  import(/* webpackChunkName: "NotificationContent" */ './NotificationContent').then((module) => ({
    default: module.NotificationContent,
  }))
);
export const Notification: FC = () => {
  const { anchors, addAnchorEl, clearAnchorEl } = useMultipleModals<'anchorEl'>();
  const anchorEl = anchors.get('anchorEl');
  const isOpen = Boolean(anchorEl);

  const haveUnreadNotifications = useSelector(notificationsToolkit.selectors.haveUnreadNotifications);
  const dispatch = useDispatch();

  const notificationID = 'snackbar-notification';

  const snackbarHistoryLogs = snackbarStorage.get(snackbarStorageKey);

  const emptySnackbarHistoryLogs = !snackbarHistoryLogs || snackbarHistoryLogs === '[]';

  useEffect(
    function markNotificationRead() {
      if (anchorEl) {
        dispatch(notificationsToolkit.actions.setUnreadNotifications(false));
      }
    },
    [anchorEl, dispatch]
  );

  const handleCloseNotifications = (event?: unknown) => {
    if ((event as SyntheticEvent & { metaKey?: boolean })?.metaKey) {
      return;
    }
    clearAnchorEl('anchorEl');
  };

  return (
    <>
      <IconButton
        color='inherit'
        aria-owns={anchorEl ? notificationID : undefined}
        aria-haspopup='true'
        aria-label='Notification'
        onClick={addAnchorEl('anchorEl')}
        size='large'
        sx={{ position: 'relative' }}
        data-testid={haveUnreadNotifications ? 'has-unread-notifications' : undefined}
      >
        {haveUnreadNotifications && <NotificationChip />}
        {emptySnackbarHistoryLogs && !haveUnreadNotifications ? <NotificationsNoneIcon /> : <NotificationsIcon />}
      </IconButton>
      {isOpen && (
        <Suspense>
          <NotificationContent anchorEl={anchorEl} onClose={handleCloseNotifications} id={notificationID} />
        </Suspense>
      )}
    </>
  );
};
